import { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { PublicShell } from "@/components/PublicShell";
import { Card } from "@/components/ui/card";
import { FileText, ArrowRight, Loader2 } from "lucide-react";

const routeFor = (key) => "/" + key.replace(/_/g, "-");

export default function PublicFormsIndex() {
  const [sp] = useSearchParams();
  const p = sp.get("p");
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/public/forms${p ? `?p=${p}` : ""}`)
      .then((r) => setData(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || "No forms available."));
  }, [p]);

  return (
    <PublicShell practiceName={data?.practice?.name}>
      <div className="mx-auto max-w-2xl">
        <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">Patient forms</h1>
        <p className="mt-2 text-sm text-muted-foreground">Choose a form to complete. It only takes a few minutes.</p>
        {err && <p className="mt-6 text-sm text-muted-foreground">{err}</p>}
        {!data && !err && <div className="py-16 text-center"><Loader2 className="mx-auto h-6 w-6 animate-spin text-muted-foreground" /></div>}
        <div className="mt-6 space-y-3">
          {data?.forms?.map((f) => (
            <Link key={f.template_key} to={`${routeFor(f.template_key)}${p ? `?p=${p}` : ""}`} data-testid={`public-form-${f.template_key}`}>
              <Card className="lift flex items-center gap-4 rounded-2xl border-border/60 p-5">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary"><FileText className="h-5 w-5" /></div>
                <div className="min-w-0 flex-1">
                  <div className="font-semibold">{f.title}</div>
                  {f.description && <div className="truncate text-xs text-muted-foreground">{f.description}</div>}
                </div>
                <ArrowRight className="h-4 w-4 text-muted-foreground" />
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </PublicShell>
  );
}
